import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4a8 8 0 110 16 8 8 0 010-16zm10 8c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zm-10.501-.399l.5-1.06.496 1.052 1.325.199-.963.977.206 1.255-1.067-.584-1.066.584.205-1.255-.954-.97 1.318-.198zm5.46-.847a.88.88 0 00-.703-.618l-2.408-.363-1.07-2.262A.867.867 0 0011.996 7a.867.867 0 00-.782.51l-1.07 2.273-2.407.362a.88.88 0 00-.695.616.931.931 0 00.217.922l1.738 1.765-.408 2.498c-.054.34.08.68.347.882a.84.84 0 00.913.069l2.147-1.177 2.147 1.177a.84.84 0 00.913-.069.923.923 0 00.348-.881l-.409-2.499 1.739-1.765c.239-.24.326-.6.224-.929z",
      fill: "#2d6ded"
    }
  )
), t = a;
export {
  t as default
};
